import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Material } from '../../../models/material.model';

@Component({
  standalone: false,
  selector: 'app-alternative-material',
  templateUrl: './alternative-material.component.html',
  styleUrls: ['../modal.component.scss']
})
export class AlternativeMaterialComponent {
  @Input() material: Material;
  selectedMaterial: Material;
  @Output() readonly submitMaterial = new EventEmitter();

  onSelectMaterial(material: Material): void {
    this.selectedMaterial = material;
  }

  emitTrue(): void {
    this.submitMaterial.emit(this.selectedMaterial);
  }

  emitFalse(): void {
    this.submitMaterial.emit(null);
  }
}
